import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

// Size scale — `default` is the historical compact input (h-8) used by
// filters and inline forms. `lg` (h-10 / 15px) is the form-field size the
// Create Agent flow (and future wizards) reach for.
const inputVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground/70 selection:bg-primary selection:text-primary-foreground w-full min-w-0 rounded-md border border-border bg-background transition-colors outline-none file:inline-flex file:border-0 file:bg-transparent file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 focus-visible:border-ring aria-invalid:border-destructive",
  {
    variants: {
      size: {
        default: "h-8 px-2.5 text-[13px] file:h-6 file:text-xs",
        lg: "h-10 px-3 text-base file:h-7 file:text-sm",
      },
    },
    defaultVariants: { size: "default" },
  },
);

export interface InputProps
  extends
    Omit<React.ComponentProps<"input">, "size">,
    VariantProps<typeof inputVariants> {}

function Input({ className, type, size, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      data-size={size ?? "default"}
      className={cn(inputVariants({ size, className }))}
      {...props}
    />
  );
}

export { Input, inputVariants };
